// extracted by mini-css-extract-plugin
export default {"dropdown--with-delete":"components-settings-budget-forecast-menu-entry-module__dropdown--with-delete"};